import React from 'react';
import { useParams, Link } from 'react-router-dom';
import '../App.css';

const serviceData = {
  'kitchen-design-planning': {
    title: 'Kitchen Design & Planning',
    icon: '🏗️',
    description: 'Complete design solutions from concept to completion, including layout optimization and space planning.',
    images: [
      'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-6940b9786e3c?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912167-f556f1f39f4a?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-2c0b4f4b2c6c?w=800&auto=format&fit=crop'
    ],
    features: [
      'Complete design solutions from concept to completion',
      'Layout optimization and space planning',
      '3D visualization and design mockups',
      'Material selection and sourcing',
      'Budget planning and cost estimation',
      'Project timeline and milestone planning'
    ]
  },
  'custom-cabinetry': {
    title: 'Custom Cabinetry',
    icon: '🎨',
    description: 'Bespoke cabinetry designed to maximize storage and complement your kitchen\'s aesthetic.',
    images: [
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-6940b9786e3c?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912167-f556f1f39f4a?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-2c0b4f4b2c6c?w=800&auto=format&fit=crop'
    ],
    features: [
      'Bespoke cabinetry designed to your specifications',
      'Maximize storage with intelligent design',
      'Custom finishes and hardware selection',
      'Quality materials and craftsmanship',
      'Perfect fit for your space',
      'Complements your kitchen\'s aesthetic'
    ]
  },
  'premium-materials': {
    title: 'Premium Materials',
    icon: '💎',
    description: 'Access to high-quality countertops, backsplashes, and fixtures from trusted suppliers.',
    images: [
      'https://images.unsplash.com/photo-1556912173-6940b9786e3c?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912167-f556f1f39f4a?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-2c0b4f4b2c6c?w=800&auto=format&fit=crop'
    ],
    features: [
      'High-quality countertops and surfaces',
      'Premium backsplashes and tiles',
      'Trusted supplier network',
      'Wide range of materials and finishes',
      'Quality assurance and warranties',
      'Competitive pricing'
    ]
  },
  'installation-renovation': {
    title: 'Installation & Renovation',
    icon: '🔧',
    description: 'Professional installation services ensuring your kitchen is built to last with attention to detail.',
    images: [
      'https://images.unsplash.com/photo-1556912167-f556f1f39f4a?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-6940b9786e3c?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-2c0b4f4b2c6c?w=800&auto=format&fit=crop'
    ],
    features: [
      'Professional installation by skilled craftsmen',
      'Complete renovation services',
      'Quality assurance and attention to detail',
      'Timely project completion',
      'Clean-up and final inspection',
      'Post-installation support'
    ]
  },
  'lighting-design': {
    title: 'Lighting Design',
    icon: '💡',
    description: 'Strategic lighting solutions to create ambiance and enhance functionality in your kitchen space.',
    images: [
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-6940b9786e3c?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912167-f556f1f39f4a?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-2c0b4f4b2c6c?w=800&auto=format&fit=crop'
    ],
    features: [
      'Strategic lighting design and planning',
      'Ambient, task, and accent lighting',
      'Energy-efficient LED solutions',
      'Smart lighting controls',
      'Enhance functionality and ambiance',
      'Professional installation'
    ]
  },
  '3d-visualization': {
    title: '3D Visualization',
    icon: '🎯',
    description: 'See your dream kitchen before it\'s built with our advanced 3D design and visualization tools.',
    images: [
      'https://images.unsplash.com/photo-1556912173-2c0b4f4b2c6c?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912173-6940b9786e3c?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556912167-f556f1f39f4a?w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&auto=format&fit=crop'
    ],
    features: [
      'Advanced 3D design and visualization',
      'See your kitchen before it\'s built',
      'Realistic material and color rendering',
      'Virtual reality walkthroughs',
      'Easy design modifications',
      'Share and collaborate on designs'
    ]
  }
};

function ServiceDetail() {
  const { serviceId } = useParams();
  const service = serviceData[serviceId];

  if (!service) {
    return (
      <div className="service-detail-container">
        <div className="container">
          <h1>Service Not Found</h1>
          <Link to="/#services" className="cta-button">Back to Services</Link>
        </div>
      </div>
    );
  }

  const handleGetQuote = () => {
    window.location.href = '/#contact';
  };

  return (
    <div className="service-detail-container">
      <div className="service-detail-header">
        <div className="container">
          <Link to="/#services" className="back-link">← Back to Services</Link>
          <div className="service-header-content">
            <div className="service-header-icon">{service.icon}</div>
            <div>
              <h1 className="service-detail-title">{service.title}</h1>
              <p className="service-detail-subtitle">{service.description}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        {/* Image Gallery */}
        <div className="service-images-grid">
          {service.images.map((image, index) => (
            <div key={index} className="service-image-card">
              <img 
                src={image} 
                alt={`${service.title} - Image ${index + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {/* Features Section */}
        <div className="service-features-section">
          <h2 className="section-title">Special Features</h2>
          <div className="service-features-grid">
            {service.features.map((feature, index) => (
              <div key={index} className="service-feature-card">
                <div className="feature-icon">✓</div>
                <p>{feature}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Get Quote Section */}
        <div className="service-quote-section">
          <div className="quote-card">
            <h2>Ready to Transform Your Kitchen?</h2>
            <p>Get a free consultation and quote for your {service.title.toLowerCase()} project</p>
            <button onClick={handleGetQuote} className="cta-button quote-button">
              Get a Quote
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceDetail;

